import Card from "@/atoms/account/Card";
import { CardTitle } from "@/account/typography";
import Divider from "@/atoms/account/Divider";
import React, { useContext, useState } from "react";
import ConnectAccountModal from "components/authenticate/ConnectAccountModal";
import {
  FacebookLoginButton,
  GoogleLoginButton,
} from "components/authenticate";
import { AuthContext } from "contexts/AuthProvider";
import ConnectAccountButton from "components/authenticate/ConnectAccountButton";
import ConfirmDisconnectAccountModal from "components/authenticate/ConfirmDisconnectAccountModal";
import styled from "styled-components";

const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

const SocialAccounts = () => {
  const [accountToDisconnect, setAccountToDisconnect] = useState(null);
  const [providerData, setProviderData] = useState();

  const { validatePassword, linkProvider, unlinkProvider, user } =
    useContext(AuthContext);

  const handleSubmitPassword = async (credentials) => {
    let res = await validatePassword({ ...credentials });
    if (!res.error) {
      res = linkProvider({
        providerData,
        onSuccess: () => setProviderData(null),
        toastOnError: false,
      });
    }
    return res;
  };

  const handleToken = async ({ token, provider }) => {
    setProviderData({ token, provider });
  };

  const connectedAccounts = user?.socialAccounts;

  const handleUnlink = async (provider) => {
    return unlinkProvider({
      payload: {
        provider,
        external_uid: connectedAccounts[provider],
      },
      onSuccess: () => setAccountToDisconnect(null),
    });
  };

  return (
    <Card>
      <CardTitle>Connected Accounts</CardTitle>
      <p className={"text-xs text-textGray-lighter mt-2"}>
        Log in with ease by connecting to your other accounts.
      </p>
      <Divider className={"my-4"} />
      {connectedAccounts && (
        <ButtonsContainer>
          <ConnectAccountButton
            type={"Facebook"}
            onDisconnect={() => setAccountToDisconnect("facebook")}
            connected={!!connectedAccounts["facebook"]}
            renderConnectButton={() => (
              <FacebookLoginButton onToken={handleToken} />
            )}
          />
          <ConnectAccountButton
            type={"Google"}
            onDisconnect={() => setAccountToDisconnect("google")}
            connected={!!connectedAccounts["google"]}
            renderConnectButton={() => (
              <GoogleLoginButton onToken={handleToken} disableAutoTap />
            )}
          />
        </ButtonsContainer>
      )}
      <ConnectAccountModal
        isOpen={!!providerData}
        onClose={() => setProviderData(null)}
        type={providerData?.provider}
        providerData={providerData}
        login={user?.email}
        onSubmit={handleSubmitPassword}
      />
      <ConfirmDisconnectAccountModal
        isOpen={!!accountToDisconnect}
        onClose={() => setAccountToDisconnect(null)}
        onConfirm={() => handleUnlink(accountToDisconnect)}
        provider={accountToDisconnect}
      />
    </Card>
  );
};

export default SocialAccounts;
